import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {
        this.element.classList.add("cursor-pointer")
        this.element.title = "Cliquez pour agrandir"
    }

    open(e) {
        if (e) {
            e.preventDefault()
            e.stopPropagation()
        }

        // Determine the high-resolution image URL. 
        // Fallback to the element's src or background-image if data-lightbox-url is not provided.
        let imageUrl = this.element.dataset.lightboxUrl

        if (!imageUrl) {
            if (this.element.tagName === "IMG") {
                imageUrl = this.element.src
            } else {
                const bgImage = window.getComputedStyle(this.element).backgroundImage
                imageUrl = bgImage.replace(/^url\(['"]?/, "").replace(/['"]?\)$/, "")
            }
        }

        if (!imageUrl || imageUrl === "none") return

        // Create the overlay container
        this.overlay = document.createElement("div")
        this.overlay.className = "fixed inset-0 z-[9999] flex items-center justify-center p-4 sm:p-6 lg:p-12 transition-all duration-300 opacity-0 bg-black/90 backdrop-blur-md"

        // Allow clicking the overlay to close
        this.overlay.addEventListener("click", this.close.bind(this))

        // Create the wrapper for the image for proper animations
        const imgWrapper = document.createElement("div")
        imgWrapper.className = "relative w-full h-full flex items-center justify-center max-w-7xl mx-auto"

        // Create the image element
        const img = document.createElement("img")
        img.src = imageUrl
        img.className = "max-w-full max-h-[90vh] object-contain rounded-2xl shadow-2xl scale-95 transition-transform duration-300"

        // Prevent closing when clicking the image itself
        img.addEventListener("click", (e) => e.stopPropagation())

        // Create a close button
        const closeBtn = document.createElement("button")
        closeBtn.className = "absolute top-4 right-4 sm:top-6 sm:right-6 text-white/70 hover:text-white bg-black/50 hover:bg-black/80 rounded-full p-2 transition-all cursor-pointer backdrop-blur-md z-10"
        closeBtn.innerHTML = `<svg class="w-6 h-6 sm:w-8 sm:h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>`
        closeBtn.addEventListener("click", this.close.bind(this))

        // Assemble
        imgWrapper.appendChild(img)
        this.overlay.appendChild(imgWrapper)
        this.overlay.appendChild(closeBtn)
        document.body.appendChild(this.overlay)

        // Lock body scroll
        document.body.style.overflow = "hidden"

        // Trigger animations
        requestAnimationFrame(() => {
            this.overlay.classList.remove("opacity-0")
            this.overlay.classList.add("opacity-100")
            img.classList.remove("scale-95")
            img.classList.add("scale-100")
        })

        // Add escape key listener
        this.escapeListener = (e) => {
            if (e.key === "Escape") this.close()
        }
        document.addEventListener("keydown", this.escapeListener)
    }

    close(e) {
        if (e) {
            e.stopPropagation()
        }

        if (!this.overlay) return

        const img = this.overlay.querySelector("img")

        // Trigger exit animations
        this.overlay.classList.remove("opacity-100")
        this.overlay.classList.add("opacity-0")
        if (img) {
            img.classList.remove("scale-100")
            img.classList.add("scale-95")
        }

        // Wait for transition to finish before removing from DOM
        setTimeout(() => {
            if (this.overlay && this.overlay.parentNode) {
                this.overlay.parentNode.removeChild(this.overlay)
            }
            this.overlay = null

            // Unlock body scroll
            document.body.style.overflow = ""
        }, 300)

        // Remove event listener
        if (this.escapeListener) {
            document.removeEventListener("keydown", this.escapeListener)
        }
    }
}
